/* global kendo*/
const $ = kendo.jQuery

export function getDataItem(element) {
  const currentGrid = $(element)
      .closest('.k-grid')
      .data('kendoGrid'),
    row = $(element).closest('tr')

  let dataItem

  // Inline edition
  if (row.length > 0) {
    dataItem = currentGrid.dataItem(row)
  } else {
    // Pop-up edition
    dataItem = $(element)
      .closest('div[data-uid]')
      .data('kendoEditable').options.model
  }

  return dataItem
}

export function kendoNumericMultiplierKeydown(e) {
  const multiplier = {
      K: 1000,
      M: 1000000,
    },
    key = String.fromCharCode(e.keyCode)

  if (multiplier.hasOwnProperty(key)) {
    $(this)
      .val(this.value * multiplier[key])
      .trigger('change')
  }
}

// eslint-disable-next-line no-unused-vars
export function kendoNumericFocus(e) {
  var input = $(this)
  setTimeout(function() {
    input.select()
  })
}

export function gridKeyDown(e, grid) {
  function getNextEditableRow(currCell) {
    let nextEditableRow = currCell.parent().next()
    while (
      nextEditableRow.hasClass('k-group-footer') ||
      nextEditableRow.hasClass('k-grouping-row')
    ) {
      nextEditableRow = nextEditableRow.next()
    }
    if (nextEditableRow.length == 0) {
      return grid.tbody.find('tr').not('.k-grouping-row, .k-group-footer, .k-alt')[0]
    } else {
      return nextEditableRow
    }
  }
  let arrows = [13, 37, 38, 39, 40],
    keyCode = e.keyCode

  if (arrows.indexOf(keyCode) >= 0) {
    let curCell = grid.tbody.find('.editing')
    curCell.removeClass('editing')
    let cellIndex = curCell.index()
    grid.closeCell(grid.current())
    if (keyCode == 13) {
      let nextRow = getNextEditableRow(curCell, grid)
      let nextCell = $(nextRow).find('td')[cellIndex]
      $(nextCell).addClass('editing')
      grid.current(nextCell)
      grid.editCell(nextCell)
    }
  }
}

export function hideEditRow(container, name) {
  container
    .find('label[for=' + name + ']')
    .closest('.k-edit-label')
    .hide()
    .next()
    .hide()
}

export function bindEditors(e) {
  var columns = e.sender.options.columns.filter(function(x) {
    return x && x.editor
  })

  columns.forEach(function(column) {
    const container = e.container.find('[data-container-for=' + column.field + ']'),
      options = {
        field: column.field,
        model: e.model,
        format: column.format,
      }

    if (container.length == 0) {
      throw 'Container for the field "' + column.field + '" was not found'
    }

    if (typeof column.editor == 'function') {
      column.editor.call(window, container, options)
    } else {
      container.append(column.editor)
    }

    kendo.bind(container, e.model)
  })
}

export function bindEditorDetail(cols, element, model) {
  var columns = cols.filter(function(x) {
    return x && x.editor
  })

  columns.forEach(function(column) {
    var container = $(element).find('[data-container-for=' + column.field + ']'),
      options = {
        field: column.field,
        model: model,
        format: column.format,
      }

    if (container.length == 0) {
      throw 'Container for the field "' + column.field + '" was not found'
    }

    if (typeof column.editor == 'function') {
      column.editor.call(window, container, options)
    } else {
      container.append(column.editor)
    }

    kendo.bind(container, model)
  })
}

export function extendObservable(a, b) {
  Object.keys(b).forEach(function(prop) {
    var value = b[prop]
    if (typeof value == 'object' && value != null) {
      if (a.get(prop) == null) {
        a.set(prop, new kendo.data.ObservableObject())
      }
      extendObservable(a.get(prop), value)
      return
    }

    a.set(prop, value)
  })
}
